import { render } from "./Wz5Form.vue?vue&type=template&id=480f006a&scoped=true"
import script from "./Wz5Form.vue?vue&type=script&lang=js"
export * from "./Wz5Form.vue?vue&type=script&lang=js"

import "./Wz5Form.vue?vue&type=style&index=0&id=480f006a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480f006a"]])

export default __exports__